'use client'
import {
  useConfig_default
} from "./chunk-UDUUTZIS.mjs";

// src/hooks/useAppSource.ts
import { useDeviceDetect } from "@wbk/hooks";
var useAppSource = () => {
  const { appSource = "" } = useConfig_default();
  const { isWebView } = useDeviceDetect();
  return {
    appSource,
    bookingSource: `${appSource}-${isWebView ? "app" : "web"}`
  };
};

export {
  useAppSource
};
//# sourceMappingURL=chunk-7F2ZUBZJ.mjs.map